import { Box, Divider, Grid, Typography } from "@mui/material";
import Drawer, { IDefaultDrawerProps } from "../Drawer";
import { useLanguageContext } from "../../contexts/LanguageContext";
import { ServicePriorityData, ServicePropertyData, ServiceStatusData } from "../../data/Enums";
import Card from "./Card";
import { useMemo } from "react";
import DefaultConstants from "../../data/Constants";
import IServiceOrder from "../../interfaces/IServiceOrder";



const Legend: React.FC<IDefaultDrawerProps> = ({
    open,
    handleClose
}) => {
    const { translate } = useLanguageContext();


    const emptyService = useMemo(() => {
        return {
            id: 0,
            token: '',
            description: ''
        } as IServiceOrder;
    }, []);


    return (
        <Drawer
            anchor='right'
            open={open}
            handleClose={handleClose}
            title={translate('legend')}
        >
            <Grid container rowSpacing={DefaultConstants.gridRowSpacing} columnSpacing={DefaultConstants.gridColumnSpacing}>
                <Grid item xs={12}>
                    <Typography variant='subtitle2' className='fontweight-600'>{translate('priority')}</Typography>
                </Grid>

                {
                    Object.values(ServicePriorityData).map(s => {
                        return <Grid item md={6} xs={6} key={s.key}>
                            <Card
                                key={s.key}
                                title={translate(s.name)}
                                serviceOrder={{
                                    ...emptyService,
                                    description: translate(s.name),
                                    priorityId: s.key
                                }}
                                showStatusTooltip={false}
                                className="animation-none"
                            />
                        </Grid>;
                    })
                }
            </Grid>

            <Box marginTop={4} marginBottom={2}>
                <Divider />
            </Box>

            <Grid container rowSpacing={DefaultConstants.gridRowSpacing} columnSpacing={DefaultConstants.gridColumnSpacing}>
                <Grid item xs={12}>
                    <Typography variant='subtitle2' className='fontweight-600'>{translate('serviceStatus')}</Typography>
                </Grid>

                {
                    Object.values(ServiceStatusData).map(s => {
                        return <Grid item md={6} xs={6} key={s.key}>
                            <Card
                                key={s.key}
                                title={translate(s.name)}
                                serviceOrder={{
                                    ...emptyService,
                                    description: translate(s.name),
                                    statusId: s.key
                                }}
                                showStatusTooltip={false}
                                className="animation-none"
                            />
                        </Grid>;
                    })
                }
            </Grid>

            <Box marginTop={4} marginBottom={2}>
                <Divider />
            </Box>

            <Grid container rowSpacing={DefaultConstants.gridRowSpacing} columnSpacing={DefaultConstants.gridColumnSpacing}>
                <Grid item xs={12}>
                    <Typography variant='subtitle2' className='fontweight-600'>{translate('properties')}</Typography>
                </Grid>

                {
                    Object.values(ServicePropertyData).map(s => {
                        const key = s.partnerId as keyof(IServiceOrder);

                        return <Grid item md={6} xs={6} key={s.key}>
                            <Card
                                key={s.key}
                                title={translate(s.name)}
                                serviceOrder={{
                                    ...emptyService,
                                    description: translate(s.name),
                                    statusId: s.key,
                                    [key]: s.type === 'array' ? [] : (s.type === 'boolean' ? true : 0)
                                }}
                                showStatusTooltip={false}
                                className="animation-none"
                            />
                        </Grid>;
                    })
                }
            </Grid>
        </Drawer>
    )
}

export default Legend;